'use strict';

var AlgoliaSearchCore = require('../../AlgoliaSearchCore.js');
var createAlgoliasearch = require('../createAlgoliasearch.js');

module.exports = createAlgoliasearch(AlgoliaSearchCore, '(lite) ');



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/algoliasearch/src/browser/builds/algoliasearchLite.js